import {A, Component, createTextComponent, ON_CLICK} from "@juis/components";

/** An anchor that routes through the app router instead of reloading the page. */
export const createLink = (text: string, url: string, ...cssClasses: string[]): Component => {
    const link = createTextComponent(text, A, cssClasses);
    link.node.setAttribute("href", url);
    link.onDom(ON_CLICK, event => {
        event.preventDefault();
        link.navigate(url);
    });
    return link;
};
